import styled from 'styled-components';

const RoomWrapper = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  button {
    transition: opacity .25s ease-in-out;
    &:not([disabled]):hover {
      cursor: pointer;
      opacity: .8;
    }
  }
`;

export default {
  RoomWrapper
};